import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
// Sentry is temporarily disabled. Uncomment this import and initialization block to re-enable it.
// import { environment } from './environments/environment';
// import * as Sentry from '@sentry/angular';

/*
Sentry.init({
  dsn: "https://70b56da31da51b87266f2d2fcf53afde@o4510747866693632.ingest.us.sentry.io/4510747873574912",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: environment.sentryEnv,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "localhost",
    "socialnetworkfinder.com",
    /^https:\/\/(www\.)?socialnetworkfinder\.com\/api/,
    /^https:\/\/yourserver\.io\/api/
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable sending logs to Sentry
  enableLogs: true
});
*/

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
